const init = () => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("exploreNav", () => ({
      headings: [],

      init() {
        // Wait for the DOM to be fully rendered
        this.$nextTick(() => {
          this.generateHeadings();
        });
      },

      generateHeadings() {
          const pageContent = document.getElementById("main");
          if (!pageContent) return;

          // Only select h2 elements that explicitly have an ID
          const headers = pageContent.querySelectorAll("h2[id]");
          
          // Create a Set to track IDs we have already seen
          const seenIds = new Set();

          this.headings = Array.from(headers).reduce((acc, h) => {
              // Only add the heading if we haven't seen this ID before
              if (!seenIds.has(h.id)) {
                  seenIds.add(h.id);
                  acc.push({
                      id: h.id,
                      text: h.innerText,
                      type: h.tagName.toLowerCase(), // This will always be 'h2' now
                  });
              }
              return acc;
          }, []);
      },
    }));
  });
};

export default { init };